import React, { useState, useRef, useEffect } from "react";
import "./BillboardInt.css";
import { makeApiCal,GET } from "../../util";
import Image1 from "./assets/1.jpeg";
import Image2 from "./assets/2.jpeg";
import Image3 from "./assets/3.jpeg";
import Image4 from "./assets/4.jpeg";
import Image5 from "./assets/5.jpeg";
import Image6 from "./assets/6.jpeg";
import Image7 from "./assets/7.jpeg";
import Image8 from "./assets/8.jpeg";
import Image9 from "./assets/9.jpeg";
import DownloadActive from "./assets/downloadActive.jpeg";
import MyBillBoardImage from "./assets/myBillboard.png";
import html2canvas from "html2canvas";

const BillboardInt = ({data}) => {
  const locations = [
    {
      id: 1,
      value: "Beach 1",
      imageUrl: Image1,
    },
    {
      id: 2,
      value: "Beach 2",
      imageUrl: Image2,
    },
    {
      id: 3,
      value: "Desert 1",
      imageUrl: Image3
    },
    {
      id: 4,
      value: "Desert 2",
      imageUrl: Image4
    },
    {
      id: 5,
      value: "Moon",
      imageUrl: Image5
    },
    {
      id: 6,
      value: "City 1",
      imageUrl: Image6
    },
    {
      id: 7,
      value: "City 2",
      imageUrl: Image7
    },
    {
      id: 8,
      value: "City 3",
      imageUrl: Image8
    },
    {
      id: 9,
      value: "Mountains",
      imageUrl: Image9
    },
  ];
  const [selectedLocation, setSelectedLocation] = useState({});
  const handleClickLocationCard = (data) => {
    if (selectedLocation?.id === data?.id) {
      setSelectedLocation({});
    } else {
      setSelectedLocation(data);
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const [coachingName, setCoachingName] = useState("");
  const [city, setCity] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [billBoardShareScreen, setBillBoardShareScreen] = useState(false);
  const [apiData, setApiData] = useState();
	const [err, catchError] = useState(false);

  const getData = () => {
		const action = {
			method: GET,
			route: 'v2/course/categoryList/get',
			storeData: setApiData,
			catchError: catchError,
		};
		makeApiCal(action);
	};
  useEffect(()=>{
    if(data){
      setCoachingName(data)
    }
  },[data])
	useEffect(() => {
		getData();
	}, []);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };


  const downloadImage = () => {
    var userCertificate = document.getElementById("main-board");

    // userCertificate.style.width = userCertificate.clientWidth + "px"
    // userCertificate.style.height = userCertificate.clientHeight + "px"

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    html2canvas(userCertificate, { allowTaint: true }).then(function (canvas) {
      canvas.toBlob((blob) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          var base64data = reader.result;
          base64data = window.btoa(base64data);

          if (window && window.mobile && window.mobile.onDeeplinkExecuted) {
            window.mobile.onDeeplinkExecuted(
              `UTIL_BASE64_TO_IMAGE,${base64data},`
            );
            return;
          } else if (
            window &&
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.onDeeplinkExecuted
          ) {
            window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
              `UTIL_BASE64_TO_IMAGE,${base64data},my-image`
            );
          } else {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.download = "Poster.png";
            link.href = canvas.toDataURL("image/png");
            link.target = "_blank";
            link.click();
            // window.alert("Your image has been saved to gallery");
          }
        };
      });
    });
  };

  const shareImage = () => {
    var userCertificate = document.getElementById("main-board");

    // userCertificate.style.width = userCertificate.clientWidth + "px"
    // userCertificate.style.height = userCertificate.clientHeight + "px"

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

 
    // html2canvas(userCertificate, { allowTaint: true }).then(function (canvas) {

    //   canvas.toBlob((blob) => {
    //     // Check if the navigator.share() method is available
    //     if (navigator.share) {
    //       const file = new File([blob], 'certificate.png', { type: 'image/png' });
    //       navigator.share({
    //         // text: 'Check out this certificate!',
    //         files: [file],
    //       })
    //         .then(() => console.log('Shared successfully'))
    //         .catch((error) => console.error('Error sharing:', error));
    //     } else {
    //       // Fallback for browsers that don't support navigator.share()
    //       // You can provide a link for the user to download the image.
    //       var downloadLink = document.createElement('a');
    //       downloadLink.href = URL.createObjectURL(blob);
    //       downloadLink.download = 'certificate.png';
    //       downloadLink.click();
    //     }
    //   });
    // });



    html2canvas(userCertificate, { allowTaint: true }).then(function (
      canvas
    ) {
      canvas.toBlob((blob) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          var base64data = reader.result;
          base64data = window.btoa(base64data);
          if (
            window &&
            window.mobile &&
            window.mobile.onDeeplinkExecuted
          ) {
            window.mobile.onDeeplinkExecuted(
              `UTIL_SHARE_IMAGE_BASE64,${base64data},`
            );
          }

          if (
            window &&
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.onDeeplinkExecuted
          ) {
            window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
              `UTIL_SHARE_IMAGE_BASE64,${base64data}`
            );
          }
        };
      });
    });
  };

  const billBoardHeadingClass =
    city?.length < 7
      ? { fontSize: "16px", fontWeight: 600 }
      : city?.length > 10
      ? { fontSize: "10px", fontWeight: 400 }
      : { fontSize: "14px", fontWeight: 600 };

  const billBoardHeadingClassBlue =
    city?.length < 7
      ? { fontSize: "16px", fontWeight: 600, color: "#009fe4" }
      : city?.length > 10
      ? { fontSize: "10px", fontWeight: 400, color: "#009fe4" }
      : { fontSize: "14px", fontWeight: 600, color: "#009fe4" };

  const billBoardCoachingNameClass =
  coachingName?.length < 14
      ? { fontSize: "12px", fontWeight: 600, color: "white" }
      : city?.length > 24
      ? { fontSize: "6px", fontWeight: 400, width: "26%", color: "white" }
      : { fontSize: "8px", fontWeight: 500, color: "white" };
  
  const renderBillBoardImage = () => {
    return (
      <div className="billboardImageParentContainer">
        <div className="billboardImageContainer">
          <img
            // src="https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/Frame 1116599338.png"
            src={MyBillBoardImage}
            className="billboardImageContainerHeading"
          />
          {/* <div className="billboardImageContainerHeading">MY BILLBOARD</div> */}
          <div className="billboardImageCard" id="main-board">
            <div className="billboardHeadingWrapper">
              <div style={billBoardHeadingClassBlue}>{city} ka teacher,</div>
              <div style={billBoardHeadingClass}>Bharat ka future.</div>
              <div>#BharatKaTeacher</div>
            </div>
            <div className="billboardCoachingDetailsWrapper">
              <div style={billBoardCoachingNameClass}>{coachingName}</div>
              <div className="billboardCoachingCategory">{selectedOption}</div>
            </div>
            <img
              src={selectedLocation?.imageUrl}
              className="billboardImage"
            ></img>
          </div>
        </div>
        <div className="billboardFooter">
          <button className="downloadButton" onClick={() => downloadImage()}>
            {/* <div className="downloadButtonIcon">Icon</div> */}
            <img src={DownloadActive} alt="" />
            <p>Download</p>
          </button>
          <button className="shareButton" onClick={() => shareImage()}>
            <p>Share Now</p>
          </button>
        </div>
      </div>
    );
  };

  const CustomSelect = () => {
    return (
      <div className={`custom-select ${isOpen ? "open" : ""}`}>
        <div className="select-styled" onClick={toggleDropdown}>
          {selectedOption !== "" ? selectedOption : "Select an Option"}
        </div>

        <ul className="select-options">
          {apiData?.catGroupedWithSubcat?.map((option, index) => (
            <li
              key={index}
              className="select-option"
              onClick={() => handleOptionSelect(option?.name)}
            >
              {option?.name}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const checkButtonDisabled = () => {
    return (
      coachingName === "" ||
      city === "" ||
      (selectedOption === "") | (Object.keys(selectedLocation)?.length === 0)
    );
  };

  useEffect(() => {
    checkButtonDisabled();
  }, [coachingName, city, selectedOption, selectedLocation]);

  return (
    <>
      {!billBoardShareScreen ? (
        <div className="billboard-bg">
          <div className="billboard-internalbg">
            <img
              src="https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/picture.png"
              // src={BillBoardBgImage}
              style={{ width: "100%", height: "1100px" }}
            />
            <div className="billboard-heading">
              <img src="https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/Frame 1116599338.png" />
            </div>
            <div className="billboard-detailscontainer">
              <p>Please enter following details </p>
              <div className="billboard-formContainer">
                <div className="billboard-form">
                  <div className="billboard-formlabel">Coaching Name</div>
                  <input
                    className="billboard-formInput"
                    value={coachingName}
                    onChange={(e) => setCoachingName(e.target.value)}
                  ></input>
                </div>
                <div className="billboard-form">
                  <div className="billboard-formlabel">Category </div>
                  <CustomSelect />
                </div>

                <div className="billboard-form">
                  <div className="billboard-formlabel">City</div>
                  <input
                    className="billboard-formInput"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  ></input>
                </div>

                <div className="bottomContainerheading">
                  <div className="billboard-formlabel">
                    Choose your location
                  </div>
                </div>

                <div className="cardsContainer">
                {locations.map((item) => {
                    return (
                      <div
                        className="locationCardContainer"
                        onClick={() => handleClickLocationCard(item)}
                        key={item?.id}
                      >
                        <div
                          className={`locationCard ${
                            selectedLocation?.id === item?.id
                              ? `locationCardActive`
                              : ""
                          }`}
                        >
                          <img
                            src={item?.imageUrl}
                            className="locationCardImage"
                          />
                        </div>
                        <div className="locationCardTitle">{item?.value}</div>
                      </div>
                    );
                  })}
                </div>

                {/* <div className="cardsContainer">
                {locations.slice(0, 3).map((item) => {
                    return (
                      <div
                        className="locationCardContainer"
                        onClick={() => handleClickLocationCard(item)}
                        key={item?.id}
                      >
                        <div
                          className={`locationCard ${
                            selectedLocation?.value === item?.value
                              ? `locationCardActive`
                              : ""
                          }`}
                        >
                          <img
                            src={item?.imageUrl}
                            className="locationCardImage"
                          />
                        </div>
                        <div className="locationCardTitle">{item?.value}</div>
                      </div>
                    );
                  })}
                </div>

                <div className="cardsContainer cardsContainerBottom">
                  {locations.slice(-3).map((item) => {
                    return (
                      <div
                        className="locationCardContainer"
                        onClick={() => handleClickLocationCard(item)}
                        key={item?.id}
                      >
                        <div
                          className={`locationCard ${
                            selectedLocation?.value === item?.value
                              ? `locationCardActive`
                              : ""
                          }`}
                        >
                          <img
                            src={item?.imageUrl}
                            className="locationCardImage"
                          />
                        </div>
                        <div className="locationCardTitle">{item?.value}</div>
                      </div>
                    );
                  })}
                </div> */}

                <div className="billboardCreateButtonContainer">
                  <button
                    className="billboardCreateButton"
                    disabled={checkButtonDisabled()}
                    onClick={() => setBillBoardShareScreen(true)}
                  >
                    Create My Billboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        renderBillBoardImage()
      )}
    </>
  );
};

export default BillboardInt;

//     // const handleShareImgBase = () => {
//     //     // document.getElementById("main-board").style.display = "flex";
//     //     document.body.scrollTop = 0; // For Safari
// 		// document.documentElement.scrollTop = 0;
//     //     domtoimage
//     //       .toBlob(document.getElementById("main-board"))
//     //       .then(function (dataUrl) {
//     //         var reader = new FileReader();
//     //         reader.readAsDataURL(dataUrl);
//     //         reader.onloadend = function () {
//     //           var base64data = reader.result;
//     //           base64data = btoa(base64data);
    
//     //           if (window && window.mobile && window.mobile.onDeeplinkExecuted) {
                
//     //             window.mobile.onDeeplinkExecuted(
//     //               `UTIL_SHARE_IMAGE_BASE64,${base64data},`
//     //             );
//     //           }
    
//     //           if (
//     //             window &&
//     //             window.webkit &&
//     //             window.webkit.messageHandlers &&
//     //             window.webkit.messageHandlers.onDeeplinkExecuted
//     //           ) {
//     //             window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
//     //               `UTIL_SHARE_IMAGE_BASE64,${base64data}`
//     //             );
//     //           }
//     //         };
//     //       });
//     //   };


//       const handleShareImgBase = () => {
//         var userCertificate = document.getElementById('main-board');
      
//         // userCertificate.style.width = userCertificate.clientWidth + "px"
//         // userCertificate.style.height = userCertificate.clientHeight + "px"
    
//         document.body.scrollTop = 0; // For Safari
//         document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    
//         html2canvas(userCertificate, { allowTaint: true }).then(
//           function (canvas) {
//             canvas.toBlob((blob) => {
//               var reader = new FileReader();
//               reader.readAsDataURL(blob);
//               reader.onloadend = function () {
//                 var base64data = reader.result;
//                 base64data = window.btoa(base64data);
//                 if (window && window.mobile && window.mobile.onDeeplinkExecuted) {
                
//                   window.mobile.onDeeplinkExecuted(
//                     `UTIL_SHARE_IMAGE_BASE64,${base64data},`
//                   );
//                 }
      
//                 if (
//                   window &&
//                   window.webkit &&
//                   window.webkit.messageHandlers &&
//                   window.webkit.messageHandlers.onDeeplinkExecuted
//                 ) {
//                   window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
//                     `UTIL_SHARE_IMAGE_BASE64,${base64data}`
//                   );
//                 }
              
//               };
//             });
//           }
//         );
//       };